<div>
    <img src='/assets/images/de.png'>
</div>